module.exports = __webpack_public_path__ + "static/img/logo-white.c051df91.png";